import {initialState} from "../initialState";
import {
    FETCH_HISTORY_BEGAN, FETCH_HISTORY_SUCCESS,
    FETCH_MY_BATTERIES_BEGAN,
    FETCH_MY_BATTERIES_FAILED,
    FETCH_MY_BATTERIES_SUCCESS

} from "../actionTypes/myBatteries";
import moment from 'moment'


const myBatteriesReducer = (state = initialState.myBatteries, action) => {
    switch (action.type) {
        case FETCH_MY_BATTERIES_BEGAN:
            return {
                ...state,
                fetching: true,
                error: null
            }

        case FETCH_MY_BATTERIES_SUCCESS:
            return {
                ...state,
                fetching: false,
                batteries: action.payload,
                lastUpdated: moment()
            }

        case FETCH_MY_BATTERIES_FAILED:
            return {
                ...state,
                fetching: false,
                error: action.payload
            }


        default:
            return state
    }
}

export default myBatteriesReducer


// SELECTORS

export const myBatteriesSelector = state => state.myBatteries.batteries
export const fetchingBatteriesSelector = state => state.myBatteries.fetching
export const fetchingBatteriesErrorSelector = state => state.myBatteries.fetching
export const lastUpdatedSelector = state => state.myBatteries.lastUpdated